'use client';

const DEVICE_ID_KEY = 'deviceId';

let cachedDeviceId: string | null = null;

const readStoredDeviceId = (): string | null => {
  try {
    return localStorage.getItem(DEVICE_ID_KEY);
  } catch {
    return null;
  }
};

const persistDeviceId = (deviceId: string) => {
  try {
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  } catch {
    return;
  }
};

export const getDeviceId = (): string => {
  if (cachedDeviceId) {
    return cachedDeviceId;
  }

  const storedDeviceId = readStoredDeviceId();

  if (storedDeviceId) {
    cachedDeviceId = storedDeviceId;
    return storedDeviceId;
  }

  cachedDeviceId = crypto.randomUUID();
  persistDeviceId(cachedDeviceId);

  return cachedDeviceId;
};

export const resetDeviceIdCache = () => {
  cachedDeviceId = null;
};
